const filterVisiblePlatforms = (platforms, isPlatformVisible) => {
  const list = Array.isArray(platforms) ? platforms : [];
  if (typeof isPlatformVisible !== "function") return list;
  return list.filter((platform) => isPlatformVisible(platform?.slug));
};

module.exports = { filterVisiblePlatforms };
